// extracted by mini-css-extract-plugin
export var content = "InclusionsModalTabContent-module--content--7ef3f";
export var icon = "InclusionsModalTabContent-module--icon--ee0df";
export var title = "InclusionsModalTabContent-module--title--3d101";
export var wrapper = "InclusionsModalTabContent-module--wrapper--8f6b7";